module.exports = __webpack_public_path__ + "static/img/zhangjiawei.404ca2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhangjiawei.png
// module id = T7A6
// module chunks = 1